(() => {
  'use strict';
  const api = 'https://app.galerieindra.com/api';
  const countries = [
    {
      name:"Canada",
      regions:[
        {
          name:"Alberta"
        },
        {
          name:"British Columbia"
        },
        {
          name:"Manitoba"
        },
        {
          name:"New Brunswick"
        }, 
        {
          name:"Newfoundland and Labrador"
        },
        {
          name:"Nova Scotia"
        },
        {
          name:"Ontario"
        }, 
        {
          name:"Prince Edward Island"
        },
        {
          name:"Quebec"
        },
        {
          name:"Saskatchewan"
        }, 
        {
          name:"Northwest Territories"
        },
        {
          name:"Nanavut"
        },
        {
          name:"Yukon"
        },         
      ]
    },
    {
      name:"United States",
      regions:[
        {
          name:'Alabama'
        },
        {
          name:'Alaska'
        },
        {
          name:'Arizona'
        },
        {
          name:'Arkansas'
        },
        {
          name:'California'
        }, 
        {
          name:'Colorado'
        },
        {
          name:'Connecticut'
        },
        {
          name:'Delaware'
        },
        {
          name:'Florida'
        },
        {
          name:'Georgia'
        }, 
        {
          name:'Hawaii'
        },
        {
          name:'Idaho'
        },
        {
          name:'Illinois'
        },
        {
          name:'Indiana'
        },
        {
          name:'Iowa'
        }, 
        {
          name:'Kansas'
        },
        {
          name:'Kentucky'
        },
        {
          name:'Lousiana'
        },
        {
          name:'Main'
        },
        {
          name:'Maryland'
        }, 
        {
          name:'Massachusetts'
        },
        {
          name:'Michigan'
        },
        {
          name:'Minnesota'
        },
        {
          name:'Mississippi'
        },
        {
          name:'Missouri'
        }, 
        {
          name:'Montana'
        },
        {
          name:'Nebraska'
        },
        {
          name:'Nevada'
        },
        {
          name:'New Hampshire'
        },
        {
          name:'New Jersey'
        }, 
        {
          name:'New Mexico'
        },
        {
          name:'New York'
        },
        {
          name:'North Carolina'
        },
        {
          name:'North Dakota'
        },
        {
          name:'Ohio'
        }, 
        {
          name:'Oklahoma'
        },
        {
          name:'Oregon'
        },
        {
          name:'Pennsylvania'
        },
        {
          name:'Rhode Island'
        },
        {
          name:'South Carolina'
        }, 
        {
          name:'South Dakota'
        },
        {
          name:'Tennessee'
        },
        {
          name:'Texas'
        },
        {
          name:'Utah'
        },
        {
          name:'Vermont'
        }, 
        {
          name:'Virginia'
        },
        {
          name:'Washington'
        },
        {
          name:'West Virginia'
        },
        {
          name:'Wisconsin'
        },
        {
          name:'Wyoming'
        },         
      ]
    }
  ];
  const statusRequests = new Map();

  function showState(root, state) {
    root.querySelectorAll('[data-access-panel]').forEach(panel => {
      panel.hidden = panel.dataset.accessPanel !== state;
    });
    const form = root.querySelector('[data-application-form]');
    if (form) form.hidden = state !== 'required';
  }

  async function request(path, payload) {
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(api + path, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
        signal: controller.signal
      });
      const body = await response.json();
      return { response, body };
    } finally {
      window.clearTimeout(timer);
    }
  }

  async function checkStatus(root, refresh = false) {
    const email = root.dataset.customerEmail;
    if (!email) return;
    showState(root, 'checking');
    try {
      if (refresh) statusRequests.delete(email);
      if (!statusRequests.has(email)) {
        statusRequests.set(email, request('/customer-application-status', { email }));
      }
      const { response, body } = await statusRequests.get(email);
      if (!response.ok || typeof body.application_exists !== 'boolean') throw new Error('Status unavailable');
      showState(root, body.application_exists ? 'pending' : 'required');
    } catch (_) {
      statusRequests.delete(email);
      showState(root, 'error');
    }
  }

  function setupApplication(root) {
    const form = root.querySelector('[data-application-form]');
    if (!form) return;
    const copy = JSON.parse(root.querySelector('[data-application-copy]').textContent);
    const country = form.elements.namedItem('country');
    const province = form.elements.namedItem('province');
    countries.forEach(item => country.add(new Option(item.name, item.name)));
    country.addEventListener('change', () => {
      province.length = 1;
      const selected = countries.find(item => item.name === country.value);
      (selected?.regions || []).forEach(region => province.add(new Option(region.name, region.name)));
    });
    country.value = 'Canada';
    country.dispatchEvent(new Event('change'));
    const button = form.querySelector('[data-application-submit]');
    button.disabled = false;
    let submitting = false;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (submitting) return;
      const summary = form.querySelector('[data-application-errors]');
      summary.hidden = true;
      form.querySelectorAll('[data-error-for]').forEach(error => { error.hidden = true; error.textContent = ''; });
      form.querySelectorAll('[aria-invalid]').forEach(field => field.removeAttribute('aria-invalid'));
      if (!form.reportValidity()) return;
      const data = Object.fromEntries(new FormData(form));
      data.email = data.email.trim().toLowerCase();
      data.phone = data.phone.replace(/\D/g, '');
      if (data.phone.length === 11 && data.phone.startsWith('1')) data.phone = data.phone.slice(1);
      submitting = true;
      button.disabled = true;
      button.textContent = copy.submitting;
      form.setAttribute('aria-busy', 'true');
      try {
        const { response, body } = await request('/account-applications', data);
        if (response.ok && body.success === true) {
          form.hidden = true;
          root.querySelectorAll('[data-access-panel]').forEach(panel => { panel.hidden = true; });
          const success = root.querySelector('[data-application-success]');
          success.hidden = false;
          success.focus();
          statusRequests.delete(data.email);
          return;
        }
        summary.textContent = response.status === 422 ? copy.errors : copy.failed;
        summary.hidden = false;
        const errors = body.errors || {};
        Object.entries(errors).forEach(([name, messages]) => {
          const field = form.elements.namedItem(name);
          const message = [...form.querySelectorAll('[data-error-for]')].find(item => item.dataset.errorFor === name);
          if (field) field.setAttribute('aria-invalid', 'true');
          if (message) {
            message.textContent = Array.isArray(messages) ? messages.join(' ') : String(messages);
            message.hidden = false;
          }
        });
        summary.focus();
      } catch (_) {
        summary.textContent = copy.failed;
        summary.hidden = false;
        summary.focus();
      } finally {
        submitting = false;
        button.disabled = false;
        button.textContent = copy.submit;
        form.removeAttribute('aria-busy');
      }
    });
  }

  function initialize(container = document) {
    container.querySelectorAll('[data-customer-access], [data-account-application]').forEach(root => {
      if (root.dataset.accessInitialized) return;
      root.dataset.accessInitialized = 'true';
      if (root.hasAttribute('data-account-application')) setupApplication(root);
      root.querySelectorAll('[data-access-retry]').forEach(button => {
        button.addEventListener('click', () => checkStatus(root, true));
      });
      if (root.dataset.accessState === 'pending') checkStatus(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
